import React from 'react';
import { connect } from  'react-redux';
import { Redirect, Link } from 'react-router-dom';
import {api} from '../../actions/_request';
// styling
import './style.css';
import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';

import _ from 'underscore';

import Departamentos from './reporte_departamento';
import Individual from './reporte_individual';

import * as actions from '../../actions/auth';

class Reportesantonio extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            fecha_inicio:'',
            fecha_final:'',
        
        };
        this.fecha = this.fecha.bind(this);
    }

    fecha(fecha1,fecha2){

        this.setState({
                 fecha_inicio:fecha1,
                 fecha_final:fecha2,
            });

    }

    componentDidMount(){

        let self = this;
        api().get('/fecha_inicio_final')
        .then(function(response)
        {
            self.fecha(response.data.inicio,response.data.final);
            console.log('fechas--->',response.data.inicio);
           
        });
    }
    render()
    {
        
        return(
            <div className="view">
                <div className="view-content view-components">
                    <Card className="mb-4">
                        <CardBlock>
                        <Departamentos inicio={this.state.fecha_inicio} final={this.state.fecha_final} cambio_fechas={this.fecha}/>
                        <Individual inicio={this.state.fecha_inicio} final={this.state.fecha_final} cambio_fechas={this.fecha}/>
                        <br/><br/><br/><br/><br/><br/><br/><br/>
                        </CardBlock>
                    </Card>
                </div>  
            </div>
            );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        auth : state.auth,
    }
};

export default connect(mapStateToProps, actions)(Reportesantonio)




// WEBPACK FOOTER //
// ./src/views/dashboard/reportesantonio.js